import React, { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { tableColumns } from '../../pages/ValidatingAttendancesByManager/logic/dataTable.js';
import AttendanceTableManager from './components/AttendanceTableManager/AttendanceTableManager';
import './ValidatingAttendancesByManager.scss';
import Mouse from '../../components/Mouse/Mouse.jsx';
import ScrollTop from '../../components/ScrollTop/ScrollTop.jsx';
import FlatTitle from '../LandingPage/components/ContactUs/components/FlatTitle.jsx';

function ValidatingAttendancesByManager() {
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [calendarVisible, setCalendarVisible] = useState(false);
    const handleDateChange = (date) => {
      setSelectedDate(date);
      setCalendarVisible(false);
    };

    const toggleCalendar = () => {
      setCalendarVisible(!calendarVisible);
    };


    return (
        <div>
            <FlatTitle pageName={"Attendance React Training Session "} />
            <div className="section-container">
                <div id="wrapper">
                <div className="AttendanceTrainerView">
                    <div className="Attendance-title">
                        <label>Attendance React Training Session</label>
                    </div>

                    <div className="date-picker-container">
                        <div className="date-picker">
                            <select
                                value={selectedDate.toDateString()}
                                onClick={toggleCalendar} 
                            >
                                <option value={selectedDate.toDateString()}>{selectedDate.toDateString()}</option>
                            </select>
                            {calendarVisible && (
                                <Calendar
                                    className="calender"
                                    onChange={handleDateChange}
                                    value={selectedDate}
                                />
                            )}
                        </div>
                    </div>

                    <div className="attendance-table-container">
                        <AttendanceTableManager  columns={tableColumns} dateFilter={selectedDate} />
                    </div>

                </div>
                    <Mouse />
                    <ScrollTop />
                </div>
            </div>
        </div>
    )
}

export default ValidatingAttendancesByManager;
